import * as api from "../../api/notificationsApi";
const NotificationListModel = {
  state: {
    total: 0,
    notificationList: [] as Array<any>,
    isNotificationListLoading: false,
    showNotificationDisplay: false,
    platform: "HOMEPAGE",
  },
  reducers: {
    setNotificationRequest: (state: Record<string, any>): any => {
      return { ...state, isNotificationListLoading: true };
    },
    setNotificationSuccess: (
      state: Record<string, any>,
      payload: Record<string, any>
    ): any => {
      return {
        ...state,
        notificationList: payload.notificationList,
        total: payload.total,
        isNotificationListLoading: false,
      };
    },
    setNotificationListTotal: (
      state: Record<string, any>,
      payload: number
    ): any => {
      return { ...state, total: payload };
    },
    setShowNotificationDisplay: (
      state: Record<string, any>,
      payload: boolean
    ): any => {
      return { ...state, showNotificationDisplay: payload };
    },
    purgeNotificationList: (state: Record<string, any>): any => {
      return { ...state, notificationList: [], total: 0 };
    },
    setPlatform: (state: Record<string, any>, payload: number): any => {
      return { ...state, platform: payload };
    },
  },
  effects: {
    async loadNotificationList(
      payload: number,
      rootState: Record<string, any>
    ) {
      this.setNotificationRequest();
      api
        .fetchNotificationList(rootState.notificationListModel.platform)
        .then(resp => {
          this.setNotificationSuccess({
            notificationList: resp.notifications,
            total: resp.total,
          });
        });
    },
  },
};
export default NotificationListModel;
